var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFtBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 779,
    height: 59,
    viewBox: "0 0 779 59",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_205_4)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M779 77H0V24.7429C0 24.7429 40 -5.0437 124.5 24.7429C209 54.5294 226.5 48.4081 286 28.1396C345.5 7.87107 376.5 -21.766 466 24.7429C555.5 71.2517 567 -12.3597 665.5 24.7429C764 61.8454 779 24.7429 779 24.7429V77Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_205_4"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 779,
    height: 59,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFtBg);
export default __webpack_public_path__ + "static/media/ft-bg.7a1c82565894343b89a510b5ad5003d2.svg";
export { ForwardRef as ReactComponent };